module.exports = __webpack_public_path__ + "static/media/logo-slack.e88bf77b.svg";